import { IShowable } from 'Utility/SDK/Drivers/IShowable';
import { getCrossPromoRewardedVideoAsync } from 'Utility/SDK/CrossPromoRewardVideo/CrossPromoRewardedVideo';
import CrossPromoDriver, { CrossPromoAssetType, CrossPromoPlacement } from 'Utility/CrossPromo/CrossPromoDriver';
import { switchGame } from '@sgorg/x-promo-game-client';
import Game from 'Game';
import { track } from 'Utility/Tracking/Track';
import { AdType } from 'Utility/Tracking/DataSet/Ad';
import { isIOS, isOSBelowVersion } from 'Utility/Platform';

export async function getRewardedVideo(placement: string): Promise<IShowable> {
    let facebookShowable: IShowable;
    let crossPromoShowable: IShowable;

    try {
        facebookShowable = await FBInstant.getRewardedVideoAsync(placement);
    } catch {
        console.log('Fetching Facebook ad failed.');
        crossPromoShowable = await getCrossPromoShowable();

        if (crossPromoShowable !== undefined) {
            track('adSuccess', 0);
        }
    }

    return {
        loadAsync: async () => {
            if (crossPromoShowable !== undefined) {
                track('adSuccess', 0);
                track('adType', AdType.REWARDED_CROSS_PROMO);
                return crossPromoShowable.loadAsync();
            }

            try {
                console.log('Loading Facebook ad...');
                await facebookShowable.loadAsync();
                track('adType', AdType.REWARDED);
            } catch {
                console.log('Loading Facebook ad failed.');

                track('adSuccess', 0);
                crossPromoShowable = await getCrossPromoShowable();
                track('adType', AdType.REWARDED_CROSS_PROMO);
                return crossPromoShowable.loadAsync();
            }
        },
        showAsync: async () => {
            if (crossPromoShowable !== undefined) {
                track('adType', AdType.REWARDED_CROSS_PROMO);
                return crossPromoShowable.showAsync();
            }

            try {
                console.log('Showing Facebook ad...');
                await facebookShowable.showAsync();
                track('adType', AdType.REWARDED);
            } catch (e) {
                console.log('Showing Facebook ad failed.');

                if (e && e.code === 'USER_INPUT') {
                    throw e;
                }

                // Ad shown event already sent by this point so no point in tracking that the fb ad failed
                console.warn(e);
                crossPromoShowable = await getCrossPromoShowable();
                track('adType', AdType.REWARDED_CROSS_PROMO);
                return crossPromoShowable.showAsync();
            }
        }
    };
}

async function getCrossPromoShowable(): Promise<IShowable> {
    console.log('Fetching X-Promo ad...');

    if (isIOS()) return Promise.reject('cross-promo is not supported on iOS.');

    if (isOSBelowVersion('Android', 6)) return Promise.reject('cross-promo is not supported on Android 5 or below.');

    const campaign = await CrossPromoDriver.getCampaignOfType(CrossPromoPlacement.NO_REWARDED_ADS);
    if (!campaign) return Promise.reject('no cross-promo NO_REWARDED_ADS campaign found');

    const source = campaign.getAssetSource(CrossPromoAssetType.VIDEO);
    if (!source) return Promise.reject('no cross-promo NO_REWARDED_ADS campaign video found');

    // Override ad tracking.
    track('adType', AdType.REWARDED_CROSS_PROMO);

    return getCrossPromoRewardedVideoAsync({
        source,
        duration: 1000 * 10, // 10 seconds
        action: () => switchGame(campaign.id),
        cta: Game.locale.getText('InviteCTA'),
    });
}
